import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddNotification = async ( postData:any ,config: any) => {
    try {
      const response = await axios.post(`${baseURL}/notification`, postData,config);
      return response.data;
    } catch (error: any) {
      console.log(error?.response);
      if (error?.response?.data?.message === undefined) {
        throw error.message;
      } else {
        throw error?.response?.data?.message;
      }
    }
  };

 
  
  export{onAddNotification}